module.exports = __webpack_public_path__ + "static/smartpay_21-mobile-fd4ad07bf6b12a0d67038d473106e3d9.jpeg";